import { render, staticRenderFns } from "./incorrectBalanceBanner.vue?vue&type=template&id=07d8f450&scoped=true&"
import script from "./incorrectBalanceBanner.vue?vue&type=script&lang=js&"
export * from "./incorrectBalanceBanner.vue?vue&type=script&lang=js&"
import style0 from "./incorrectBalanceBanner.vue?vue&type=style&index=0&id=07d8f450&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8f450",
  null
  
)

export default component.exports